import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { CertificationsStoreContext } from '../context/StoreContext'
import { CertificationsStore } from '../store/interface'

export const useCertificationsStore: UseStore<
  CertificationsStore
> = selector => {
  return useContextStore(CertificationsStoreContext, selector)
}

export const useCertificationsStoreApi = () => {
  return useContextStoreApi(CertificationsStoreContext)
}
